<template>
  <DropdownData
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :serviceFunction="fetchData"
    placeholder="Seleccione un Producto..."
    :disabled="disabled"
  />
</template>

<script>
import DropdownData from './DropdownData.vue';
import ProductService from '@/service/ProductService'; 

export default {
  name: 'DropdownProducto',
  components: {
    DropdownData
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tipoCatalogo: {
      type: [String, Number],
      default: null
    },
    esProducido: {
      type: [String, Number, Boolean],
      default: null
    },
    esInsumo: {
      type: [String, Number, Boolean],
      default: null
    }
  },
  created() {
    this.productService = new ProductService();
  },
  methods: {
    fetchData() {
      const extraParams = {};
      if (this.esProducido !== null && this.esProducido !== undefined) {
        extraParams.es_producido = this.esProducido;
      }
      if (this.esInsumo !== null && this.esInsumo !== undefined) {
        extraParams.es_insumo = this.esInsumo;
      }
      return this.productService.getProductosCombo(this.tipoCatalogo, extraParams);
    }
  }
}
</script>
